import { getSrc } from 'gatsby-plugin-image';
import * as React from 'react';

import { IContentfulImageBlock } from '../../../utils/fragments/ImageBlockFragment';
import { OptionTile } from '../OptionTile/OptionTile';
import { useMasonryColumns } from '../useMasonryColumns';

import * as styles from './OptionTileContainer.module.less';

interface IOptionTileContainerProps {
  images: IContentfulImageBlock['images'];
  selectedItems: string[];
  onSelect: (title: string) => void;
  centered?: boolean;
  step?: number;
}

export const OptionTileContainer: React.FunctionComponent<IOptionTileContainerProps> = ({
  images,
  selectedItems,
  onSelect,
  centered,
  step,
}) => {
  const columns = useMasonryColumns(images || []);
  const itemsToRender = columns.map((column) => ({ items: column }));

  return (
    <div
      className={`${styles.optionsContainer} ${
        centered ? styles.centered : ''
      } ${step === 1 ? styles.step1OptionsContainer : ''}`}
    >
      {itemsToRender.map((column, colIndex) => (
        <div key={colIndex} className={styles.masonryColumn}>
          {column.items.map((image) => {
            const srcSet = image.gatsbyImageData?.images?.fallback?.srcSet;
            const index = images?.indexOf(image) ?? 0;
            return (
              <OptionTile
                key={image.title}
                title={image.title}
                imageSrc={getSrc(image.gatsbyImageData) || ''}
                srcSet={srcSet}
                selected={selectedItems.includes(image.title)}
                onClick={() => onSelect(image.title)}
                style={{ animationDelay: `${index * 200}ms` }}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};
